<template>
  <div class="container">
    <BlockExpansionPanelList :items="getFaqs || []" is-html />
  </div>
</template>

<script>
import BlockExpansionPanelList from '@design-system/block/expansion-panel-list/expansion-panel-list.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'FaqList',
  components: {
    BlockExpansionPanelList
  },
  computed: {
    ...mapGetters('global', ['getFaqs'])
  }
}
</script>

<style scoped>

</style>
